// extracted by mini-css-extract-plugin
export var dropdownContainer = "_s5-0";
export var leftAlign = "_s5-4";
export var listItem = "_s5-2";
export var listItemWrapper = "_s5-1";
export var operationText = "_s5-3";